export const TYPE_SOCIETE = 'Societe';
export const TYPE_HOLDING = 'Holding';

export const LISTE_SOCIETES = [
  { code: TYPE_SOCIETE, libelle: 'societes.societe' },
  { code: TYPE_HOLDING, libelle: 'societes.holding' },
];

export const PRODUIT_ID_LOCATION_PAR_DEFAUT = '00000000-0000-0000-0000-000000000000';

export const DESTINATAIRE = 'Destinataire';
export const PAYEUR = 'Payeur';
export const PREMIER_ANNONCEUR = 'PremierAnnonceur';
export const PREMIER_DONNEUR_ORDRE = 'PremierDonneurOrdre';

export const LISTE_DESTINATAIRE_COMPTABLE = [
  { code: DESTINATAIRE, libelle: 'societes.destinataireComptable.destinataire' },
  { code: PAYEUR, libelle: 'societes.destinataireComptable.payeur' },
  { code: PREMIER_ANNONCEUR, libelle: 'societes.destinataireComptable.premierAnnonceur' },
  { code: PREMIER_DONNEUR_ORDRE, libelle: 'societes.destinataireComptable.premierDonneurOrdre' },
];

export const REGIE = 'Regie';
export const MANDATAIRE_PAYEUR = 'MandatairePayeur';
export const MANDATAIRE_NON_PAYEUR = 'MandataireNonPayeur';
export const SOUS_MANDATAIRE = 'SousMandataire';

export const SOCIETE_ROLE_VENTE = [
  { code: REGIE, libelle: 'societes.role.regie' },
  { code: MANDATAIRE_PAYEUR, libelle: 'societes.role.mandatairePayeur' },
  { code: MANDATAIRE_NON_PAYEUR, libelle: 'societes.role.mandataireNonPayeur' },
  { code: SOUS_MANDATAIRE, libelle: 'societes.role.sousMandataire' },
];

export const SOCIETE_PUBLID_ID = '5dbfb742-50c1-0000-0000-000000000008';
